export { SHOPIFY_CONNECT_RETURN_QUERY_PARAM } from './constants';

export const SHOPIFY_APP_STORE_URL = 'https://apps.shopify.com/toriut-com-pim-connector';
export const SHOPIFY_APP_STORE_URL_STAGE = 'https://stage.toriut.com/auth/shopifyStore?shop=';

/** to testing local + ngrok */
export const SHOPIFY_APP_STORE_URL_DEVELOPMENT = 'https://picsio.ngrok.io/auth/shopifyStore?shop=';

export const stepLabels = {
  1: {
    title: 'Enter channel name',
    subTitle: 'Enter channel name',
  },
  2: { title: 'Sync settings', subTitle: 'Sync settings' },
  3: { title: 'Install Connector App', subTitle: 'Install Connector App' },
  4: { title: 'Configuring your install link', subTitle: 'Configuring your install link' },
  5: { title: 'Mapping fields & overrides', subTitle: 'Mapping fields & overrides' },
  6: { title: 'Import products', subTitle: 'Import products' },
};

export const SYNC_STRATEGY_ORDER = ['active', 'draft', 'unlisted', 'archived'];

export const DEFAULT_SYNC_STRATEGY = ['active', 'draft', 'unlisted'];

export const syncStrategyOptions = SYNC_STRATEGY_ORDER.map((value) => ({ value }));
